<style lang="scss">
.header {
	padding-bottom: 5px !important;
}
.overview {
	&__elipsis {
		display: block;
		min-width: 380px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	&__loading {
		img {
			height: 30px;
			margin-right: 8px;
		}
	}
}
</style>

<template lang="pug">
.overview
    submenu
        overview-submenu
    .content
        page-header
            h1.highlight Overview
            p
                company-search(v-model="companyId")
        page
            el-card
                approved-school-count(:companyId="companyId")
            el-card
                mis-breakdown(:companyId="companyId")
</template>

<script>
import UserCompaniesQuery from "@/graphql/queries/UserCompanies.js";
import OverviewSubmenu from "./includes/OverviewSubmenu";
import ApprovedSchoolCount from "./includes/ApprovedSchoolCount";
import MisBreakdown from "./includes/MisBreakdown";
import CompanySearch from "../../components/CompanySearch";

export default {
	components: {
		OverviewSubmenu,
		CompanySearch,
		ApprovedSchoolCount,
		MisBreakdown
	},
	data() {
		return {
			companyId: null
		};
	},
	apollo: {
		Companies: {
			query: UserCompaniesQuery,
			update: r => r.User.Companies
		}
	}
};
</script>
